let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1y3jr")).then(() => parcelRequire('2YHWf'));